import React, { Component } from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import AsideNavbar from '../components/navbars/AsideNavbar'
import StudentHomeSection from '../components/home/StudentHomeSection'
import HomeNavbar from '../components/home/HomeNavbar';
import * as Cookies from "es-cookie";
import Navbars from '../components/navbars/Navbars';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import PreloaderFour from '../components/preloader/PreloaderFour';
import EamcetHome from '../components/home/EamcetHome';

import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';
import { tokenChecking } from './GlobalFunctions';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";



const UPDATE_STUDENT_ANALYTICS = gql`
  mutation(
    $params:AnalyticsStudents1  
    ) {
        studentAnalytics(
        params: $params
     )
  }
`;

const SUBMIT_SCHEDULE_TEST = gql`
  mutation(
    $params:FinishStudentScheduleExam ,$uid:String 
    ) {
        finishStudentScheduleExam(
        params: $params,
        uid:$uid
     )
  }
`;


class StudentHome extends Component {
    constructor(props) {
        super(props)
        this.state = {
            headerBottomImg: {
                type: "homePage",
                title: Cookies.get("examid") == 3 ? "AP EAPCET (MPC)" : Cookies.get("examid") == 6 ? "TS EAMCET (MPC)" : Cookies.get("examid") == 7 ? "AP EAPCET (BiPC)" : Cookies.get("examid") == 8 ? "TS EAMCET (BiPC)" : Cookies.get("examid") == 9 ? "KCET (MBiPC)" : Cookies.get("examid") == 10 ? "KCET (MPC)" : "KCET (BiPC)"
            },
            mainindex: 0,
            getSubjects: [],

            toggled: isMobile == true && Cookies.get("institution_id") == 30 ? "wrapper" : Cookies.get("toggle"),
            submitError: "",
        }
    }


    menuToggler = () => {
        const toggled = this.state.toggled;
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    componentDidMount = () => {
        this.syncOfflineData();
        window.addEventListener('online', this.syncOfflineData);
        this.addStudentAnalytics();

        let title = "";
        if (Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8) {
            title = GoogleAnalyticsArray[0].Eamcet_Home;
            ReactGA.pageview('/student/home', title);
        }
        if (Cookies.get("examid") == 1 || Cookies.get("examid") == 2) {
            title = GoogleAnalyticsArray[0].Home;
            ReactGA.pageview('/student/home', title);
        }

        let globalsubjects = "";
        if (JSON.parse(localStorage.getItem("globalsubjects")) != "") {
            globalsubjects = JSON.parse(localStorage.getItem("globalsubjects"));
        }
        else {
            this.props.history.push("/student/login");
        }

        if (globalsubjects != undefined || globalsubjects != null) {
            const getSubjects = globalsubjects.map((gmap, index) => {
                if (index == 0) {
                    return { ...gmap, active: "active" }
                }
                else {
                    return { ...gmap, active: "" }
                }
            })
            this.setState({
                getSubjects: getSubjects
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('online', this.syncOfflineData);
    }

    addStudentAnalytics = e => {
        let addStudentObj = ""

        if (Cookies.get("examid") == 1 || Cookies.get("examid") == 2) {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                student_user_exam_id: parseInt(Cookies.get("student_user_exam_id") || Cookies.get("examid")),
                analytics_module_page_id: 4,
                source: 2
            }
        } else if (Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8) {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                student_user_exam_id: parseInt(Cookies.get("student_user_exam_id") || Cookies.get("examid")),
                analytics_module_page_id: 104,
                source: 2
            }
        }


        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };

    syncOfflineData = () => {
        if (!navigator.onLine) return;
        const offlineSubmission = localStorage.getItem("offline_submission");
        if (offlineSubmission) {
            try {
                const parsed = JSON.parse(offlineSubmission);
                let { params, uid } = parsed;

                // Migrate legacy variables if they exist
                if (params && (params.mobile || 'submitted_type' in params)) {
                    params = {
                        student_user_exam_id: parseInt(Cookies.get("student_user_exam_id") || Cookies.get("examid") || params.student_user_exam_id || 0),
                        source: params.source !== undefined ? params.source : 0,
                        schedule_exam_id: params.schedule_exam_id,
                        exam_session_id: parseInt(Cookies.get("exam_session_id") || params.exam_session_id || 0),
                        questions: params.questions
                    };
                }

                this.props.finishStudentScheduleExam({
                    variables: {
                        params,
                        uid
                    }
                }).then(({ data }) => {
                    if (data && data.finishStudentScheduleExam) {
                        localStorage.removeItem("offline_submission");
                        alert("Offline exam submission successful. Your results are being processed.");
                    }
                }).catch(err => {
                    console.error("Sync failed", err);
                    // If it is a BAD_USER_INPUT or graphQL validation error, clear the legacy offline submission to prevent spamming
                    if (err.message && (err.message.includes("BAD_USER_INPUT") || err.message.includes("is not defined by type"))) {
                        console.warn("Clearing invalid/unsupported legacy offline submission");
                        localStorage.removeItem("offline_submission");
                    }
                });
            } catch (e) {
                console.error("Error parsing offline submission", e);
            }
        }
    }

    handleSelect = (subid) => {
        const getSubjects = this.state.getSubjects.map((gmap, index) => {
            if (index == subid) {
                return { ...gmap, active: "active" }
            }
            else {
                return { ...gmap, active: "" }
            }
        })
        this.setState({
            getSubjects: getSubjects,
            mainindex: subid
        });
    }

    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        let isStudentUserValid = "";
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
        else {
            this.props.history.push("/student/login");
        }



        if (isStudentUserValid.isStudentUserValid != undefined) {
            if (isStudentUserValid.isStudentUserValid.estatus == 0) {
                Cookies.remove("token");
                Cookies.remove("username");
                Cookies.remove("refreshtoken");
                Cookies.remove("email");
                Cookies.remove("id");
                Cookies.remove("institutionid");
                Cookies.remove("userlevel");
                Cookies.remove("name");
                this.props.history.push("/student/login");
            }
            localStorage.removeItem('isStudentUserValid');
            localStorage.setItem(
                "isStudentUserValid",
                JSON.stringify(isStudentUserValid.isStudentUserValid)
            );
        }

        let globalsubjects = "";
        if (JSON.parse(localStorage.getItem("globalsubjects")) != "") {
            globalsubjects = JSON.parse(localStorage.getItem("globalsubjects"));
        }
        else {
            this.props.history.push("/student/login");
        }

        let studentGlobals = "";
        if (JSON.parse(localStorage.getItem("studentglobals")) != "") {
            studentGlobals = JSON.parse(localStorage.getItem("studentglobals"));
        }
        else {
            this.props.history.push("/student/login");
        }

        if (this.state.getSubjects.length
            > 0) {
            return (
                <div className={this.state.toggled}>
                    <div className="student main-wrapper">
                        <div className="student header-area">
                            {
                                (Cookies.get("examid") == 1 || Cookies.get("examid") == 2) ?
                                    (

                                        <>
                                            {
                                                <HomeNavbar
                                                    stateData={this.state}
                                                    getSubjects={this.state.getSubjects}
                                                    onClick={() => this.menuToggler()}
                                                    logout={this.props.logout}
                                                    studentGlobals={studentGlobals}
                                                    pageType={"referalfriendimage"} />
                                            }
                                        </>


                                    )
                                    :
                                    (

                                        <Navbars onClick={() => this.menuToggler()} headerBottom={this.state.headerBottomImg} />

                                    )
                            }
                        </div>
                        {/* {Cookies.get("institution_id") != "30" ? (loading5 == true) && (<PreloaderTwo />) : ""} */}
                        <AsideNavbar onClick={() => this.menuToggler()} />
                        <div className="student-overlay" onClick={() => this.menuToggler()} />
                        <div className="content-wrapper pt-0">
                            <Container>
                                {(Cookies.get("examid") == 1 || Cookies.get("examid") == 2) ? (

                                    <StudentHomeSection
                                        stateData={this.state}
                                        studentGlobals={studentGlobals}
                                        getSubjects={this.state.getSubjects}
                                        handleSelect={this.handleSelect}
                                        isStudentUserValid={isStudentUserValid} />
                                ) : (



                                    <EamcetHome
                                        stateData={this.state}
                                        studentGlobals={studentGlobals}
                                        isStudentUserValid={isStudentUserValid}
                                    />


                                )
                                }
                            </Container>
                        </div>
                    </div>
                </div>
            )
        }
        return (<PreloaderTwo />);

    }
}


export default withRouter(compose(
    graphql(UPDATE_STUDENT_ANALYTICS, {
        name: "submitpt"
    }),
    graphql(SUBMIT_SCHEDULE_TEST, {
        name: "finishStudentScheduleExam"
    }),

)(StudentHome));
